import { render, staticRenderFns } from "./ApplicantAddressDocument.vue?vue&type=template&id=8dcd90ee&"
import script from "./ApplicantAddressDocument.vue?vue&type=script&lang=js&"
export * from "./ApplicantAddressDocument.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantAddressDocument.vue?vue&type=style&index=0&id=8dcd90ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports